import { createAction } from "redux-actions"
import * as types       from "./type"

export const setCurrentMunicipality = createAction(types.SET_CURRENT_MUNICIPALITY)
export const setMunicipality = createAction(types.SET_MUNICIPALITY)
export const setCurrentWard = createAction(types.SET_CURRENT_WARD)
export const setWardProfile = createAction(types.SET_WARD_PROFILE)
